module.exports = __webpack_public_path__ + "images/3-i111b38c0a8b81b5d432c6a177d4c32e6c7c.svg";